import { MissionPromotionDisplayDto } from '../api/api.g';

export function combineMissionPromotions(displays: (MissionPromotionDisplayDto | undefined)[]): MissionPromotionDisplayDto | undefined {
  const configured = displays.filter((display): display is MissionPromotionDisplayDto => !!display);
  if (!configured.length) return undefined;
  const promotions = new Map(configured.flatMap(display => display.promotions ?? [])
    .map(promotion => [promotion.periodMissionConfigurationId, promotion]));
  const boundaries = configured.map(display => display.refreshAfterSeconds).filter((value): value is number => value != null && value > 0);
  return MissionPromotionDisplayDto.fromJS({ promotions: [...promotions.values()].map(promotion => promotion.toJSON()),
    refreshAfterSeconds: boundaries.length ? Math.min(...boundaries) : undefined });
}

/** Only traverse the mission containers returned by discovery, details and My Missions. */
export function promotionRefreshSeconds(data: unknown): number | undefined {
  if (!data || typeof data !== 'object') return undefined;
  const values: number[] = [];
  const visit = (value: unknown) => {
    if (Array.isArray(value)) { value.forEach(visit); return; }
    if (!value || typeof value !== 'object') return;
    const row = value as Record<string, unknown>;
    const seconds = (row.promotionDisplay as MissionPromotionDisplayDto | undefined)?.refreshAfterSeconds;
    if (typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0) values.push(seconds);
    const noticeSeconds = (row.scenarioUpdateNotice as { refreshAfterSeconds?: number } | undefined)?.refreshAfterSeconds;
    if (typeof noticeSeconds === 'number' && Number.isFinite(noticeSeconds) && noticeSeconds > 0) values.push(noticeSeconds);
    for (const key of ['summary', 'missionDetails', 'airports', 'highOrderMissions', 'missions', 'lowOrderMissions', 'missionsList']) visit(row[key]);
  };
  visit(data);
  return values.length ? Math.min(...values) : undefined;
}

export function promotionDateLabel(date: string, locale: string): string {
  // Calendar dates must not shift with the shopper's device time zone.
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeZone: 'UTC' }).format(new Date(`${date}T12:00:00Z`));
}
